import delayed from 'utils/functions/delayed.util';
import logger from 'utils/logger.util';
import isFn from 'utils/predicates/function/isFn.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

const L = logger('loop');

const loop = (options, callback) => {
  if (isNotFn(callback)) {
    L.error('Invalid function callback in options:', options);
    return false;
  }

  const delay = isPositiveInteger(options?.delay) ? options?.delay : 0;
  if (!Number.isSafeInteger(delay) || delay <= 0) {
    L.error('Invalid function delay:', delay);
    return false;
  }

  const onTest = isFn(options?.test) ? options.test : isFn(options?.onTest) ? options?.onTest : null;
  if (!onTest) {
    L.error('Invalid function test or onTest from options:', options);
    return false;
  }

  const onInit = isFn(options?.onInit) ? options?.onInit : null;
  const onDone = isFn(options?.onDone) ? options?.onDone : null;
  const isAwaitEnabled = options?.block;

  let id;
  let index = 0;
  const looper = async () => {
    const o = L.debug('looper()', { index, id });

    if (onInit) onInit();

    // this is equivalent to while
    if (!onTest(o)) {
      if (onDone) onDone();
      return;
    }

    const result = callback(o);

    if (isAwaitEnabled && result instanceof Promise) await result;

    index += 1;
    id = delayed(delay, looper);
  };

  delayed(delay, looper);
  return true;
};

// noinspection JSUnusedGlobalSymbols
export default loop;
